module.exports = __webpack_public_path__ + "img/img_Colleges20.63272546.jpg";